export default __webpack_public_path__ + "static/media/twitter_logo.527b141b.svg";